export const appHead = {"meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge,chrome=1"},{"name":"renderer","content":"webkit"},{"name":"force-rendering","content":"webkit"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"name":"keywords","content":"和贵科技,湖南和贵网络科技,企业数字化转型,DMS经销渠道管理,飞马外勤,即时榔,即时鸟,会员积分商城,一物一码,SaaS,新零售"},{"name":"description","content":"和贵科技是一家集技术研发、产品运营的综合性软件开发及运营公司，致力于成为企业数字化转型中最值得信赖的合作伙伴。提供DMS经销渠道管理、飞马外勤、即时榔、即时鸟新零售、会员积分商城、一物一码等企业数字化全链路方案。"},{"name":"author","content":"湖南和贵网络科技有限公司"},{"name":"robots","content":"index, follow"},{"name":"googlebot","content":"index, follow"},{"name":"baiduspider","content":"index, follow"},{"name":"generator","content":"Nuxt"},{"name":"applicable-device","content":"pc,mobile"},{"name":"format-detection","content":"telephone=no"},{"property":"og:site_name","content":"和贵科技"},{"property":"og:locale","content":"zh_CN"},{"property":"og:type","content":"website"},{"property":"og:image","content":"https://www.hnhegui.com/images/seo/og-image.png"},{"property":"og:image:secure_url","content":"https://www.hnhegui.com/images/seo/og-image.png"},{"property":"og:image:type","content":"image/png"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:image:alt","content":"和贵科技 - 企业数字化转型合作伙伴"},{"property":"article:author","content":"湖南和贵网络科技有限公司"},{"property":"article:publisher","content":"https://www.hnhegui.com"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:image","content":"https://www.hnhegui.com/images/seo/og-image.png"},{"itemprop":"name","content":"和贵科技"},{"itemprop":"description","content":"和贵科技是一家集技术研发、产品运营的综合性软件开发及运营公司，致力于成为企业数字化转型中最值得信赖的合作伙伴。"},{"itemprop":"image","content":"https://www.hnhegui.com/images/seo/og-image.png"},{"name":"image","content":"https://www.hnhegui.com/images/logo.svg"},{"name":"application-name","content":"和贵科技"},{"name":"apple-mobile-web-app-title","content":"和贵科技"},{"name":"theme-color","content":"#375FF2"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/hg-favicon.ico"}],"style":[],"script":[],"noscript":[],"titleTemplate":"%s - 和贵科技","title":"和贵科技","htmlAttrs":{"lang":"zh-CN"}}

export const appPageTransition = {"name":"app-transition-slide-fade","mode":"out-in"}

export const appLayoutTransition = {"name":"app-transition-slide-fade","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false